import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlCredentialsTable extends Layout {
    sourceContacts: DataSource;
    tableContacts: Table;
}
